import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Fade, Zoom, Slide, Rotate } from "react-awesome-reveal";
import { Link } from "react-router-dom";

const NetworkWrap: React.FC<any> = ({ group, blocks }) => {
  return (
    <>
      <div className="network-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <Slide direction="down" delay={1}>
                <h2 className="network_title">{group?.title}</h2>
                <p>{group?.description}</p>
              </Slide>

              <div className="container pb-5 mt-3">
                <div className="row">
                  <div className="col-sm-2"></div>
                  <div className="col-sm-8">
                    <div className="row row-cols-md-4 g-4">
                      <Fade direction="down">
                        {blocks?.map((row: any, index) => (
                          <div className="col" key={index}>
                            <div className="card h-100">
                              <div className="card-img-top">
                                <Zoom>
                                  <img src={row.file} alt={row.title} />
                                </Zoom>
                              </div>
                              <div className="card-body">
                                {/* <Fade cascade damping={0.5}> */}
                                <p className="card-text">{row.title}</p>
                                <h4 className="card-title"> {row.content} </h4>
                                {/* </Fade> */}
                              </div>
                            </div>
                          </div>
                        ))}
                      </Fade>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default NetworkWrap;
